import React from 'react'

export type KambiHistoryCouponDisplayContextType =
  | {
      type: 'betloop'
      utils?: Partial<{ handleDisableCopyBet(): void }>
      data?: never
    }
  | {
      type: 'betloop-quick-share'
      data: { isSelected: boolean }
      utils?: never
    }
  | {
      type: 'external-share'
      data?: never
      utils?: never
    }

/** Handles different display variations for BetInfo child components
 *  @default type: 'bet-loop' */
export const KambiHistoryCouponDisplayContext =
  React.createContext<KambiHistoryCouponDisplayContextType>({ type: 'betloop' })
